import { render, staticRenderFns } from "./customerInput.vue?vue&type=template&id=4f355edd"
import script from "./customerInput.vue?vue&type=script&lang=js"
export * from "./customerInput.vue?vue&type=script&lang=js"
import style0 from "./customerInput.vue?vue&type=style&index=0&id=4f355edd&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f355edd')) {
      api.createRecord('4f355edd', component.options)
    } else {
      api.reload('4f355edd', component.options)
    }
    module.hot.accept("./customerInput.vue?vue&type=template&id=4f355edd", function () {
      api.rerender('4f355edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/leftTopCom/customerInput.vue"
export default component.exports